import React from 'react';
import { withAuthorization } from '../Session';
import { Container, Row, Col, Button, View ,Form} from 'react-bootstrap';
import './style.css';

import * as ROUTES from '../../constants/routes';
import { NavLink } from 'react-router-dom';
class TermsConditions extends React.Component {
    _isMounted = false;
    state = {
        
    };

    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
     }
    
    
    render() {
        
        return (
            <Container className="page_content contact_us">
                <Row>
                <h1>Contact Us</h1>
<h3>Have a Question?</h3>
<h4><b>You can go through our <NavLink exact to={ROUTES.RefundPolicy}>FAQs</NavLink></b></h4>


<table>
<thead>
<tr>
<td>For Support/Enquiries</td><td>Corporate office/Communication Address</td>
</tr>
</thead>
<tbody>
<tr>
<td>
<p>WhatsApp: <a target="_blank" href="https://wa.link/1v0bpi"> 6301476353</a> (All days 9am to 6pm IST)</p>
<p>Email: <a target="_blank"  href="mailto:info@indiabuys.store">info@indiabuys.store</a></p>
</td>
<td>
<p>Shopero Retail Technologies Pvt Ltd 4th Floor,<br></br> Plot No:85, Survey No: 103 /1 Serilingampally Village,<br></br> Near Hyderabad Telangana 500019</p>
</td>
</tr>
</tbody>
</table>

                </Row>
                        
            </Container>
        );
    }
}

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(TermsConditions);
